import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { defaultCollectionCriteria, criteriaFields } from '$lib/utilities/defaultCollections.js';
import { convertTextToObject, unflattenObject, sortKeys } from 'cando-util';


export const checkCriteria = async (
	col,
	criteria,
	uid,
	store,
	tableDefaultsSettingId = "App Settings",
) => {
	if (criteria) return;
	if (typeof uid !== 'string') return;

	const defaultFormLayouts =
		convertTextToObject(
			store.settings?.docs?.[tableDefaultsSettingId]?.defaultFormLayouts
				?.value || "{}",
		) || {};
	const defaultFormLayoutClasses =
		convertTextToObject(
			store.settings?.docs?.[tableDefaultsSettingId]
				?.defaultFormLayoutClasses?.value || "{}",
		) || {};
	const defaultTableLayouts =
		convertTextToObject(
			store.settings?.docs?.[tableDefaultsSettingId]?.defaultTableLayouts
				?.value || "{}",
		) || {};

	const defaultFormLayout =
		unflattenObject(sortKeys(defaultFormLayouts))?.[col] || [];
	const defaultFormLayoutClass = defaultFormLayoutClasses[col];
	const storedDefaultTableLayout = unflattenObject(
		sortKeys(defaultTableLayouts),
	)?.[col];
	const defaultTableLayout =
		storedDefaultTableLayout ||
		(tableDefaultsSettingId === "App Settings"
			? undefined
			: { columnOrder: [] });

	const projectDefaults = {
		formLayout: defaultFormLayout,
		formLayoutClass: defaultFormLayoutClass || "p-4 space-y-4 max-h-[48rem] overflow-y-auto",
		...defaultTableLayout,
	};

	const defaultCollectionCriteriaToUse = {
		...criteriaFields,
		...defaultCollectionCriteria?.[col],
		...projectDefaults,
	};

	// can we use this as a flag to add missing criteria in userProfile?
	console.log('add default criteria to user profile');
	const updates = { [col]: defaultCollectionCriteriaToUse };
	console.log({ updates });

	const profileDocRef = doc(getFirestore(), 'profiles', uid);
	await setDoc(profileDocRef, { collectionCriteria: updates }, { merge: true });
};
